import {Exclude} from "class-transformer";
import {AbstractDictionaryApiModel} from "./abstract-dictionary.api-model";

@Exclude()
export class MakeApiModel extends AbstractDictionaryApiModel {
}
